// extracted by mini-css-extract-plugin
export default {"root":"print_root__nYRPa","page":"print_page__zcopL","box":"print_box__NWc4g","flex":"print_flex__6RAet","textRight":"print_textRight__74eCZ","summery":"print_summery__tlROW"};